export const GET_SURVEYS = 'GET_SURVEYS';
export const GET_STATISTICS = 'GET_STATISTICS';